"use client";

import { useUser } from "@clerk/nextjs";
import { usePathname } from "next/navigation";
import LandingHeader from "./LandingHeader";

const MARKETING_EXACT = new Set([
  "/",
  "/roadmap",
  "/download",
  "/privacy",
  "/terms",
  "/dpa",
  "/cookies",
  "/sitemap",
]);

const MARKETING_PREFIXES = ["/products/"];

function shouldShowHeader(pathname) {
  if (!pathname) return false;
  if (MARKETING_EXACT.has(pathname)) return true;
  return MARKETING_PREFIXES.some((p) => pathname.startsWith(p));
}

export default function LandingHeaderHost() {
  const pathname = usePathname();
  const { isSignedIn } = useUser();
  if (!shouldShowHeader(pathname)) return null;
  return <LandingHeader isAuthenticated={Boolean(isSignedIn)} />;
}
